<template>
<div class="dboard">
  <div class="dboard-header">
    <portal target-el="#filter">
      <PrimaryFilter v-if="!isLoading && !transporterLoading" placeholder="Search by User name"
        :menuOptions="$checkMenuOptions(dashboardOptions)"
        :selectedCategory="selectedCategory"
        :options="depots"
        :seletedOption="currentDepots"
        :activeIntends="activeIntends"
        :months="months"
        :selectedMonth="selectedMonth"
        :transporterList="transporterList"
        :selectedTransporter="selectedTransporter"
        :years="years"
        :selectedYear="selectedYear"
        @depotchange="depotchange"
        @transporterchange="transporterchange"
        @daychange="daychange"
        @monthchange="monthchange"
        @yearchange="yearchange" />
    </portal>
  </div>

  <Empty v-if="showEmptyState"/>
  <div v-else class="row dboard">
    <div class="col-lg-3">
       <TotalNew v-if="!isSlaLoading" :isLoading="isCountLoading" :count="countdata"
      :activeIntends="activeIntends" :sladata="sladata"/>
        <IndentedNew v-if="!isSlaLoading" :isLoading="isCountLoading" :count="countdata"
      :activeIntends="activeIntends" />
    </div>

    <div class="col-lg-5">
      <Delivered :isLoading="isCountLoading && isTransporterLoading"
        :count="countdata"
        :transporter="transporterdata"/>
      <Arrived :isLoading="isCountLoading && isSlaLoading"
        :count="countdata" :sla="sladata"/>
    </div>

    <div class="col-lg-4">
      <OrderDelivery v-if="sladata"
      :isLoading="isCountLoading && isSlaLoading" :count="countdata" :sla="sladata.sla"/>
      <Capacity :isLoading="isVehicletypeLoading"
      :selectedTransporter="selectedTransporter"
      :day="day"
      :vehicletype="vehicletypedata"
      :selectedMonth="selectedMonth"
      :selectedYear="selectedYear"
      :selectedDepot="selectedDepot"
      :multiSelectedDepotIds="multiSelectedDepotIds"
      />
      <Kpi :isLoading="isKPILoading" :kpidata="kpidata"/>
    </div>

  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { dashboardMenu } from '@/constants/dashboardConstants';
import Indented from '@/components/dashboard/Indented';
import Dispatched from '@/components/dashboard/Dispatched';
import Delivered from '@/components/dashboard/Delivered';
import Arrived from '@/components/dashboard/Arrived';
import Capacity from '@/components/dashboard/Capacity';
import OrderDelivery from '@/components/dashboard/OrderDelivery';
import Empty from '@/components/dashboard/Empty';
import Kpi from '@/components/dashboard/Kpi';
import PrimaryFilter from '@/components/dashboard/dbFilter';
import TotalNew from '@/components/dashboard/TotalNew';
import IndentedNew from '@/components/dashboard/IndentedNew';

export default {
  components: {
    Indented,
    Dispatched,
    Delivered,
    Arrived,
    Capacity,
    PrimaryFilter,
    Empty,
    OrderDelivery,
    Kpi,
    TotalNew,
    IndentedNew,
  },
  async created() {
    this.selectedMonth = this.months[(new Date()).getMonth()];
    this.selectedYear = this.years[0];
    this.transporterLoading = true;
    const list = await this.$store.dispatch('dashboard/transporterlist');
    if (list) {
      list.unshift({ id: 0, name: 'All Transporters' });
      this.transporterList = list;
      this.selectedTransporter = list[0];
    }
    this.transporterLoading = false;
  },
  computed: {
    ...mapGetters({
      isLoading: 'app/isLoading',
      depots: 'app/depots',
      configurations: 'app/configurations',
      dashboardOptions: 'app/dashboardOptions',
    }),
    currentDepots() {
      if (this.selectedDepotId === null) {
        this.selectedDepotId = this.depots[0].id;
      }
      if (!this.gettersMapped) {
        this.fetch();
        this.gettersMapped = true;
      }
      if (this.selectedDepotId.split(',').length === 1) {
        this.selectedDepot = this.depots.find(depot => depot.id === this.selectedDepotId);
      } else {
        this.selectedDepot = null;
      }
      this.multiSelectedDepotIds = this.selectedDepotId;// comma separated depot ids
      return this.selectedDepotId;
    },
    showEmptyState() {
      return this.activeIntends <= 0;
    },
    selectedCategory() {
      return this.dashboardMenu.find(menu => menu.id === 'LiveDashboard');
    },
  },
  methods: {
    depotchange(depot) {
      this.selectedDepotId = depot;
      this.selectedDepotId = this.selectedDepotId.reduce((accumulator, currentValue, currentIndex) => {
        if (currentIndex === 0) {
          accumulator = currentValue;
        } else {
          accumulator += `,${currentValue}`;
        }
        return accumulator;
      }, '');
      this.fetch();
    },
    monthchange(month) {
      this.selectedMonth = month;
      this.fetch();
    },
    yearchange(year) {
      this.selectedYear = year;
      this.fetch();
    },
    transporterchange(transporter) {
      this.selectedTransporter = transporter;
      this.fetch();
    },
    fetch() {
      this.count();
      this.transporter();
      this.sla();
      this.vehicletype();
      this.kpi();
    },
    async count() {
      this.isCountLoading = true;
      let param = { year: this.selectedYear.name, depot_id: this.selectedDepotId };
      param = this.prepareResponse(param);
      const result = await this.$store.dispatch('dashboard/count', param);
      this.isCountLoading = false;
      // active indents count should not include delivery_pending or delivered
      this.activeIntends = result.indented + result.truck_assigned
       + result.truck_arrived + result.reported + result.dispatched + result.indent_accepted
       + result.indent_rejected + result.indent_assign_due + result.indent_accept_due
       + result.indent_arrived_due + result.loading_started + result.loading_ended
       + result.truck_rejected + result.truck_change_requested;
      this.countdata = result;
    },
    async transporter() {
      this.isTransporterLoading = true;
      let param = { year: this.selectedYear.name, depot_id: this.selectedDepotId };
      param = this.prepareResponse(param);
      if (param.transporter_id) {
        delete param.transporter_id;
      }
      const result = await this.$store.dispatch('dashboard/transporter', param);
      this.isTransporterLoading = false;
      this.transporterdata = result;
    },
    async sla() {
      this.isSlaLoading = true;
      let param = { year: this.selectedYear.name, depot_id: this.selectedDepotId };
      param = this.prepareResponse(param);
      const result = await this.$store.dispatch('dashboard/sla', param);
      this.isSlaLoading = false;
      this.sladata = result;
    },
    async vehicletype() {
      this.isVehicletypeLoading = true;
      let param = { year: this.selectedYear.name, depot_id: this.selectedDepotId };
      param = this.prepareResponse(param);
      const result = await this.$store.dispatch('dashboard/vehicletype', param);
      this.isVehicletypeLoading = false;
      this.vehicletypedata = result;
    },
    async kpi() {
      this.isKPILoading = true;
      let param = { year: this.selectedYear.name, depot_id: this.selectedDepotId };
      param = this.prepareResponse(param);
      const result = await this.$store.dispatch('dashboard/kpi', param);
      this.isKPILoading = false;
      this.kpidata = result;
    },
    prepareResponse(obj) {
      if (this.day && this.day.id !== 0) {
        const date = new Date(`${this.selectedMonth.id}/${this.day.name}/${this.selectedYear.name}`);
        obj.date = date.toISOString();
        delete obj.year;
      } else {
        obj.month = this.selectedMonth.name.toLowerCase();
      }
      if (this.selectedTransporter && this.selectedTransporter.id !== 0) {
        obj.transporter_id = this.selectedTransporter.id;
      }
      return obj;
    },
    daychange(day) {
      this.day = day;
      this.fetch();
    },
  },
  data() {
    return {
      activeIntends: 0,
      dashboardMenu,
      selectedDepot: null,
      multiSelectedDepotIds: null,
      selectedDepotId: null,
      isCountLoading: true,
      vehicletypedata: null,
      isKPILoading: false,
      transporterdata: [],
      selectedTransporter: null,
      transporterLoading: false,
      sladata: null,
      kpidata: [],
      day: null,
      months: [
        { id: 1, name: 'January' },
        { id: 2, name: 'February' },
        { id: 3, name: 'March' },
        { id: 4, name: 'April' },
        { id: 5, name: 'May' },
        { id: 6, name: 'June' },
        { id: 7, name: 'July' },
        { id: 8, name: 'August' },
        { id: 9, name: 'September' },
        { id: 10, name: 'October' },
        { id: 11, name: 'November' },
        { id: 12, name: 'December' }],
      years: Array.from(Array(2).keys()).map((val, index) => ({ id: index, name: (new Date()).getFullYear() - val })),
    };
  },
};
</script>
<style lang="scss">
.hide-filter .filter-btn-group {
  display: none;
}
</style>
